import { render, staticRenderFns } from "./SurplusManagerDashboard2.vue?vue&type=template&id=4798ef17&scoped=true&"
import script from "./SurplusManagerDashboard2.vue?vue&type=script&lang=js&"
export * from "./SurplusManagerDashboard2.vue?vue&type=script&lang=js&"
import style0 from "./SurplusManagerDashboard2.vue?vue&type=style&index=0&id=4798ef17&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4798ef17",
  null
  
)

export default component.exports